import { useEffect, useState } from 'react';
import { Spin, Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import TabelaConciliadorBancario from '../../components/TabelaConciliadorBancario';
import api from '../../service/api';
import { User } from '../acess';
import { Header as CustomHeader } from '../../components/Header/Header';

const { Content } = Layout;

const ConciliacaoBancaria: React.FC = () => {
    const [isSpinning, setIsSpinning] = useState<boolean>(true);
    const antIcon = <LoadingOutlined style={{ fontSize: 34, color: "#2ce414" }} spin />;
    const [currentUser, setCurrentUser] = useState<User>();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const id = queryParams.get('id') ||
        (location.state as any)?.id ||
        JSON.parse(localStorage.getItem('cliente') || '{}').id;

    useEffect(() => {
        const errorHandler = (e: ErrorEvent) => {
            if (e.message.includes('ResizeObserver loop completed')) {
                const resizeObserverErrGuid = '800dfa42-7041-4ef4-9640-c9772c3d90f2';
                e.stopImmediatePropagation();
            }
        };
        window.addEventListener('error', errorHandler);
        return () => window.removeEventListener('error', errorHandler);
    }, []);

    useEffect(() => {
        async function GetCliente() {
            if (!id || id === "undefined") {
                setIsSpinning(false);
                return;
            }

            try {
                const response = await api.get(`api/Cliente/${id}`);
                setCurrentUser(response.data);
                if (response.data) {
                    localStorage.setItem('cliente', JSON.stringify(response.data));
                }
            } catch (error) {
                console.error("Erro na API:", error);
            } finally {
                setIsSpinning(false);
            }
        }
        GetCliente();
    }, [id]);

    const menuOptions = [
        { label: 'CONCILIADOR VENDAS', url: `/ConciliacaoVendas?id=${id}`, newTab: true },
        { label: 'EXTRATOS BANCÁRIOS', url: `/ListaExtratos?id=${id}` },
        { label: 'PORTAL ADMINISTRADORAS', url: `https://login.assessoriacartoes.com.br/redirect/${id}`, newTab: true },
    ];

    return (
        <Spin indicator={antIcon} spinning={isSpinning}>
            <CustomHeader
                logoUrl={currentUser?.img ? `data:image/png;base64,${currentUser.img}` : ""}
                title="Conciliador Bancário"
                options={menuOptions}
            />

            <Layout className="layout">
                <Content style={{
                    backgroundColor: "white",
                    padding: '0 50px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column'
                }}>
                    {currentUser && <TabelaConciliadorBancario currentUser={currentUser} />}
                </Content>
            </Layout>
        </Spin>
    );
}

export default ConciliacaoBancaria;